__turbopack_export_value__({
  "body-logo-18": "BurgerMenu-module-scss-module__Vb4haG__body-logo-18",
  "body-text-12": "BurgerMenu-module-scss-module__Vb4haG__body-text-12",
  "body-text-14": "BurgerMenu-module-scss-module__Vb4haG__body-text-14",
  "body-text-16": "BurgerMenu-module-scss-module__Vb4haG__body-text-16",
  "body-text-18": "BurgerMenu-module-scss-module__Vb4haG__body-text-18",
  "body-text-20": "BurgerMenu-module-scss-module__Vb4haG__body-text-20",
  "body-text-24": "BurgerMenu-module-scss-module__Vb4haG__body-text-24",
  "body-text-24-2": "BurgerMenu-module-scss-module__Vb4haG__body-text-24-2",
  "body-text-heading-2": "BurgerMenu-module-scss-module__Vb4haG__body-text-heading-2",
  "body-text-heading-3": "BurgerMenu-module-scss-module__Vb4haG__body-text-heading-3",
  "body-text-medium-14": "BurgerMenu-module-scss-module__Vb4haG__body-text-medium-14",
  "body-text-medium-16": "BurgerMenu-module-scss-module__Vb4haG__body-text-medium-16",
  "body-text-medium-18": "BurgerMenu-module-scss-module__Vb4haG__body-text-medium-18",
  "body-text-medium2-18": "BurgerMenu-module-scss-module__Vb4haG__body-text-medium2-18",
  "body-text2-14": "BurgerMenu-module-scss-module__Vb4haG__body-text2-14",
  "body-text2-16": "BurgerMenu-module-scss-module__Vb4haG__body-text2-16",
  "burgerButton": "BurgerMenu-module-scss-module__Vb4haG__burgerButton",
  "button-primary-text": "BurgerMenu-module-scss-module__Vb4haG__button-primary-text",
  "button-text": "BurgerMenu-module-scss-module__Vb4haG__button-text",
  "button2-text": "BurgerMenu-module-scss-module__Vb4haG__button2-text",
  "card-shadow": "BurgerMenu-module-scss-module__Vb4haG__card-shadow",
  "contactUs": "BurgerMenu-module-scss-module__Vb4haG__contactUs",
  "contactUs__orderButton": "BurgerMenu-module-scss-module__Vb4haG__contactUs__orderButton",
  "contactUs__phone": "BurgerMenu-module-scss-module__Vb4haG__contactUs__phone",
  "contactUs__shedule": "BurgerMenu-module-scss-module__Vb4haG__contactUs__shedule",
  "contactUs__statusWrapper": "BurgerMenu-module-scss-module__Vb4haG__contactUs__statusWrapper",
  "contactUs__title": "BurgerMenu-module-scss-module__Vb4haG__contactUs__title",
  "effect-menu": "BurgerMenu-module-scss-module__Vb4haG__effect-menu",
  "header-1": "BurgerMenu-module-scss-module__Vb4haG__header-1",
  "main-container": "BurgerMenu-module-scss-module__Vb4haG__main-container",
  "main-footer-container": "BurgerMenu-module-scss-module__Vb4haG__main-footer-container",
  "main-header-container": "BurgerMenu-module-scss-module__Vb4haG__main-header-container",
  "menu__link": "BurgerMenu-module-scss-module__Vb4haG__menu__link",
  "menu__list": "BurgerMenu-module-scss-module__Vb4haG__menu__list",
  "menu__title": "BurgerMenu-module-scss-module__Vb4haG__menu__title",
  "mobileMenu": "BurgerMenu-module-scss-module__Vb4haG__mobileMenu",
  "mobileMenu_opened": "BurgerMenu-module-scss-module__Vb4haG__mobileMenu_opened",
  "specialButton": "BurgerMenu-module-scss-module__Vb4haG__specialButton",
  "txt-12-bold": "BurgerMenu-module-scss-module__Vb4haG__txt-12-bold",
  "txt-14-bold": "BurgerMenu-module-scss-module__Vb4haG__txt-14-bold",
  "txt-14-bold-caps": "BurgerMenu-module-scss-module__Vb4haG__txt-14-bold-caps",
  "txt-14-med": "BurgerMenu-module-scss-module__Vb4haG__txt-14-med",
  "txt-16-bold": "BurgerMenu-module-scss-module__Vb4haG__txt-16-bold",
  "txt-16-med": "BurgerMenu-module-scss-module__Vb4haG__txt-16-med",
  "txt-18-bold": "BurgerMenu-module-scss-module__Vb4haG__txt-18-bold",
  "txt-18-medium": "BurgerMenu-module-scss-module__Vb4haG__txt-18-medium",
  "txt-18-medium-24": "BurgerMenu-module-scss-module__Vb4haG__txt-18-medium-24",
  "txt-24-semi": "BurgerMenu-module-scss-module__Vb4haG__txt-24-semi",
});
